import { createContext, useContext, useState } from "react";

const NotificationContext = createContext();

export const useNotifications = () => useContext(NotificationContext);

export function NotificationProvider({ children }) {
  const [notifications, setNotifications] = useState([]);

  const playSound = () => {
    const audio = new Audio("/notification.mp3");
    audio.volume = 0.5;
    audio.play().catch(() => {});
  };

  const removeNotification = (id) => {
    setNotifications((prev) => prev.filter((n) => n.id !== id));
  };

  const pushNotification = (notif) => {
    const id = Date.now();

    setNotifications((prev) => [
      { id, ...notif },
      ...prev
    ]);

    playSound();

    setTimeout(() => {
      removeNotification(id);
    }, 5000);
  };

  return (
    <NotificationContext.Provider value={{ pushNotification }}>
      {children}

      {/* 🔔 UI */}
      <div style={styles.container}>
        {notifications.map((n) => (
          <div
            key={n.id}
            style={styles.toast}
            onClick={() => {
              window.dispatchEvent(
                new CustomEvent("openChat", {
                  detail: { chatId: n.chatId }
                })
              );

              removeNotification(n.id); // 💥 сразу закрываем
            }}
          >
            <img
              src={n.avatar || "/default-avatar.png"}
              style={styles.avatar}
              alt=""
            />

            <div style={styles.text}>
                <div>{n.title}</div>
                <div>{n.text}</div>
                </div>

            <div
              style={styles.close}
              onClick={(e) => {
                e.stopPropagation();
                removeNotification(n.id);
              }}
            >
              ✕
            </div>
          </div>
        ))}
      </div>
    </NotificationContext.Provider>
  );
}

const styles = {
  container: {
    position: "fixed",
    right: 20,
    bottom: 20,
    display: "flex",
    flexDirection: "column",
    gap: 10,
    zIndex: 9999,
  },

  toast: {
    minWidth: 260,
    padding: "14px 16px",
    borderRadius: 14,
    background: "rgba(255,255,255,0.06)",
    border: "1px solid rgba(255,255,255,0.12)",
    backdropFilter: "blur(20px)",
    color: "#fff",

    display: "flex",
    gap: 12,
    alignItems: "center",

    animation: "slideIn 0.3s ease",
    cursor: "pointer",
  },

  avatar: {
    width: 36,
    height: 36,
    borderRadius: "50%",
    objectFit: "cover",
  },

  text: {
    fontSize: 13,
    flex: 1,
  },

  close: {
    cursor: "pointer",
    opacity: 0.6,
  },
};